var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronUpBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.81289 7.87039C10.9734 6.70987 12.8666 6.70987 14.0271 7.87039L20.5471 14.3904C20.9376 14.7809 20.9376 15.4141 20.5471 15.8046C20.1566 16.1951 19.5234 16.1951 19.1329 15.8046L12.6129 9.28461C12.2334 8.90513 11.6066 8.90513 11.2271 9.28461L4.70711 15.8046C4.31658 16.1951 3.68342 16.1951 3.29289 15.8046C2.90237 15.4141 2.90237 14.7809 3.29289 14.3904L9.81289 7.87039Z",
    fill: "#515E5F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUpBig);
export default __webpack_public_path__ + "static/media/ChevronUpBig.36ee46f3be24882a28b5def729243cd8.svg";
export { ForwardRef as ReactComponent };